module.exports = __webpack_public_path__ + "media/Video 134b.dec65528.mp4";